import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.sass']
})
export class ImprintComponent implements OnInit {

  constructor(
    private titleService: Title,
    private translocoService: TranslocoService
  ) { }

  ngOnInit() {

    this.translocoService.selectTranslate('imprint')
      .pipe(take(1))
      .subscribe(value => {
        this.titleService.setTitle(value + ' – ReZA');
      });

  }

}
